
import MHeader from '../../Header/Header.vue';
import dateFormat from 'vux/src/tools/date/format.js'

import {
coinExchange
} from '../../../api';
export default {
data() {
return {
data: ""
}
},
methods: {
withdrawal() {
if (this.data.avail_num < 1000) {
this.$store.commit('updateToast', {
show: true,
text: '酒币1000以上才可以提现哦！'
});
}
},
coinExchange() {
this.$store.commit('showIsLoading');
coinExchange().then(res => {
if (res.data.error_code) {
alert(res.data.msg);
console.error(res);
return;
};
this.data = res.data;
console.log(res);
});
}
},
components: {
MHeader
},
filters: {
createTimer(val) {
return dateFormat(new Date(val * 1000), 'YYYY-MM-DD HH:mm:ss')
}
},
created() {

},
beforeRouteEnter: (to, from, next) => {
var pathName = from.name;
if (pathName == 'wineMoneyRules' || pathName == 'wineMoneyDetail') {
next();
} else {
next(vm => {
vm.coinExchange();
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/wineMoney/wineMoney.vue